module.exports = "/build/web/svg/minus.0b096616e8d8f62599feeaabb6b5dde3.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/minus.svg
// module id = 173
// module chunks = 24